import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
    ViewEncapsulation,
} from '@angular/core';

@Component({
    selector: 'cmps-user-profile-component',
    template: `
        <div class="cmps-user-profile-container">
            <div class="cmps-user-profile-wrapper">
                <div class="cmps-user-profile-image">
                    <img
                        [src]="profileImgUrl"
                        alt="profile-image"
                    />
                </div>
            </div>
            <div class="cmps-user-profile-labels-container">
                <div class="cmps-user-profile-name-label">
                    <h4>{{ nameLabel }}</h4>
                </div>
                <div class="cmps-user-profile-group-type-label">
                    <p>{{ groupTypeLabel }}</p>
                </div>
            </div>
            <div class="cmps-user-profile-search-actions">
                <button
                    class="cmps-icon-button--no-bg"
                    cmpsIconButton
                    (click)="searchAction.emit($event)"
                >
                    <cmps-icon svgIcon="__internal:search"></cmps-icon>
                </button>
            </div>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class CmpsUserProfileComponent {
    @Input() profileImgUrl: string;
    @Input() nameLabel: boolean;
    @Input() groupTypeLabel: string;

    @Output() searchAction: EventEmitter<MouseEvent | KeyboardEvent>;

    constructor() {
        this.searchAction = new EventEmitter();
    }

    ngOnDestroy(): void {
        this.searchAction.complete();
    }
}
